export function registerRedirect() {
    window.location.href = 'https://meetingbaas.com/signup/'
}

export function transcriptSeeker() {
    window.open('https://meetingbaas.com/transcript-seeker/', '_blank')
}

export function baasDocumentation() {
    window.open('https://doc.meetingbaas.com/', '_blank')
}

export function cloneOnGithub() {
    window.open('https://github.com/Meeting-Baas/transcript-seeker', '_blank')
}

export function openGoogleApiReference() {
    window.open('https://developers.google.com/meet/api/guides/artifacts', '_blank')
}

export function loginRedirect() {
    window.location.href = 'https://meetingbaas.com/login'
}

export function joinDiscord() {
    window.open('https://discord.com/invite/dsvFgDTr6c', '_blank')
}

export function inviteDiscord() {
    window.open('https://discord.com/invite/dsvFgDTr6c', '_blank')
}

export function redirectToMeetingBaas() {
    window.open('https://meetingbaas.com/')
}
export function redirectLocalToMeetingBaas() {
    window.location.href = 'https://meetingbaas.com/'
}

export function openSpoke() {
    window.open('https://spoke.app', '_blank')
}

export function openRecallCompetitor() {
    window.open('https://recall.ai', '_blank')
}
